<template>
  <div class="part-list">
    <div v-if="isPartSelected" class="part-list-image-section">
      <div v-if="!isDrawingSelected" class="part-wrapper-image">
        <img :src="project.selectedPart.thumbUrl" alt="part image" :title="project.selectedPart.data.name">
      </div>
      <div v-if="isDrawingSelected && !isDrawingVisible" @click="showExplodedView(project.selectedDrawing.id)" class="part-wrapper-image">
        <img :src="project.selectedDrawing.thumbUrl" alt="drawing image">
      </div>
      <div v-if="isDrawingVisible" class="part-wrapper-image">
        <img :src="project.selectedDrawing.thumbUrl" alt="drawing image">
      </div>
    </div>

    <div v-if="isDrawingSelected" class="project-tree-title theme-fontname" >
      <span>{{project.selectedDrawing.name}}</span>
      <div style="margin-left:auto">
        <v-btn text icon @click="expandOrCollapseAll"  v-if="isDrawingListVisible">
          <img :src="project.uxd.expandallicon" style="width:24px;height:24px"/>
        </v-btn>
      </div>
    </div>

    <div v-if="isPartSelected && !isDrawingVisible" class="project-tree-content">
      <div class="project-tree-title theme-fontname" v-if="!isDrawingSelected">
        <span>{{project.selectedPart.data.name}}</span>
        <span v-if="project.selectedPart.showRev" class="revision">{{project.selectedPart.data.revision}}</span>
        <div style="margin-left:auto">
          <v-btn text icon @click="expandOrCollapseAll" v-if="isDrawingListVisible">
            <img :src="project.uxd.expandallicon" style="width:24px;height:24px"/>
          </v-btn>
        </div>
      </div>
      <ul class="drawing-list" v-if="isDrawingListVisible" id="ptree">
        <li class="drawing-list-item ecatalog-extlink theme-fontname" 
            v-for="extLink in project.selectedPart.data.extlinks" 
            v-bind:key="extLink.id"
            :title="extLink.purpose"
            @click.self="openExternalProjectLink(extLink)">
          {{ extLink.name }}
        </li>

        <li class="drawing-list-item theme-fontname" @click.self="selectFromLeftPanel(drawing)" v-bind:key="drawing.id"
            v-for="drawing in project.selectedPart.data.drawings"
            :style="drawingNodeStyle(drawing)"
            :class="drawingNodeClasses(drawing)"
            :title="drawing.name">
              <span :style="'margin-left:' + ((drawing.level - project.selectedPart.level) - 1) * 12 + 'px;'">
                <v-icon v-if="drawing.hasChildren && drawing.isExpanded" @click="collapseNode(drawing)">mdi-chevron-down</v-icon>
                <v-icon v-if="drawing.hasChildren && !drawing.isExpanded" @click="expandNode(drawing)">mdi-chevron-right</v-icon>
                <v-icon v-if="!drawing.hasChildren" style="visibility:hidden">mdi-arrow-right</v-icon>
                <span @click.self="selectFromLeftPanel(drawing)" >{{ drawing.name }}</span>
              </span>
        </li>
      </ul>
      <ul class="part-list" v-if="isPartListVisible">
        <li class="theme-fontname" v-bind:key="p.id" @click="selectPartOrRootDrawingById(p.id)" v-for="p in project.currentLevelParts">
          <div >
            {{p.data.name}}
            <span v-if="p.showRev" class="revision">{{p.data.revision}}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters, mapState} from 'vuex'
  export default {
    name: 'ProjectTree',
    data () {
      return {
        msg: ''}
    },
    computed: {
      ...mapState([
        'project'
      ]),
      ...mapGetters([
        'parentPartId',
        'selectedPartId',
        'isPartSelected',
        'selectedDrawingId',
        'isDrawingSelected',
        'isPartListVisible',
        'isDrawingListVisible',
        'isDrawingVisible'
      ])
    },
    methods: {
      ...mapActions([
        'getHotspots',
        'selectParentPart',
        'selectDrawing',
        'selectDrawingById',
        'showDrawingById',
        'selectPart',
        'selectPartOrRootDrawingById',
        'showDrawing',
        'levelUp',
        'saveTreeState',
        'expandOrCollapseAll',
        'showExplodedView',
        'savePartScroll',
        'clearPartScroll'
      ]),
      selectFromLeftPanel (drw) {
        this.savePartScroll();
        if (drw.hasChildren) {
          drw.isExpanded = true
          this.saveTreeState();
          this.selectDrawingById(drw.id)
        } else {
          this.showDrawingById(drw.id)
        }
      },
      showExplodedView(drwId) {
        let drawingToShow = this.project.drawingMap[drwId];
        let part = this.project.parts[drawingToShow.partIndex];
        if(!this.project.uxd.thumbnavtosubassy || (this.project.uxd.thumbnavtosubassy && drawingToShow.hscount > 0)) {
          this.selectPartOrRootDrawingById(part.id);
          this.showDrawingById(drwId);
        }
      },
      collapseNode (drw) {
        this.clearPartScroll();
        drw.isExpanded = false;
        let desc = this.project.selectedPart.data.drawings.filter(x => x.parent === drw.id && x.hasChildren).map(x => x.id)
        while (desc.length > 0) {
          let id = desc.shift();
          let descdrw = this.project.selectedPart.data.drawings.find(x => x.id === id)
          if (descdrw !== null) {
            descdrw.isExpanded = false
            if (descdrw.hasChildren) {
              desc = desc.concat(this.project.selectedPart.data.drawings.filter(x => x.parent === id && x.hasChildren).map(x => x.id))
            }
          }
        }
        this.saveTreeState()
      },
      expandNode (drw) {
        this.clearPartScroll();
         drw.isExpanded = true;
         this.saveTreeState();
         this.selectDrawingById(drw.id);
      },
      drawingNodeStyle (drw) {
        // If any ancestors are collapsed, do not show the drawing node
        if (drw === null) return ''
        let hideIt = false
        let parentId = drw.parent
        while (parentId !== -1) {
          let parent = this.project.selectedPart.data.drawings.find(x => x.id === parentId)
          if (!parent.isExpanded) {
            hideIt = true
            break
          }
          parentId = parent.parent
        }
        let style = 'font-size:0.75em;display:' + (hideIt ? 'none' : 'flex')

        return style
      },
      drawingNodeClasses (drw) {
        let classes = 'text-no-wrap text-truncate'
        if (drw !== null && this.project.selectedDrawing !== null && this.project.selectedDrawing.id === drw.id) {
          classes += ' focused '
        }
        if (this.project.selectedDrawing !== null) {
          if (drw.id === this.project.selectedDrawing.id) {
            classes += ' theme-listselback1 theme-listseltext '
          } else if (drw.parent === this.project.selectedDrawing.id) {
            classes += ' theme-listselback2'
          }
        }
        return classes
      },
      expandIcon () {
        return this.project.selectedPart.data.drawings.some(x => x.hasChildren && !x.isExpanded) ? 'mdi-unfold-more-horizontal' : 'mdi-unfold-less-horizontal'
      },
      openExternalProjectLink(link) {
        window.open(link.url, link.context);
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  ul.part-list, ul.drawing-list  {
    list-style-type: none;
    word-wrap: break-word;
    padding: 5px;
  }

</style>
